/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/coalesce.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns the first of its arguments that is not null. If all arguments are null, it returns `null`.',
  examples: [
    'ROW a=null, b="b"\n| EVAL COALESCE(a, b)',
  ],
  params: {
    first: 'Expression to evaluate.',
    rest: 'Other expression to evaluate.',
  },
};

export default docs;
